import React from 'react';
import { MissionCard } from './card/MissionCard';
import { stylesheet } from 'typestyle';
import { ScheduleHeader } from './ScheduleHeader';
import { useSelectedMissionsTab } from '../useSelectedMissionsTab';
import { Alert, typeCompact14RegularProperties } from '@traceair/tds';
import { containerCss } from './styles';
import { MissionTab } from '../../../../consts/missionTab';
import { NotFound } from './NotFound';
import { useFilteredMissions } from './useFilteredMissions';
import { useCurrentUserType } from '../../../../hooks/useCurrentUserType';
import { UserType } from '../../../../consts/userType';

const css = stylesheet({
  section: {
    $nest: {
      '&:not(:last-child)': {
        marginBottom: 24,
      },
    },
  },
  moderatorAlert: {
    marginBottom: 24,
  },
  uploadsNote: {
    ...typeCompact14RegularProperties,
    margin: '-6px 0 34px',
  },
});

export const SchedulesTab = () => {
  const { missionsKeyedByDates, sortedDates } = useFilteredMissions();
  const selectedMissionsTab = useSelectedMissionsTab();
  const userType = useCurrentUserType();

  if (!sortedDates.length) {
    return <NotFound />;
  }

  return (
    <div className={containerCss.container}>
      {userType === UserType.Moderator && (
        <Alert
          className={css.moderatorAlert}
          type="attention"
          title="You have moderator access"
          description="This tab lists all scheduled scans within ±1 week and all active GCP Placement Services."
        />
      )}

      {selectedMissionsTab === MissionTab.Uploaded && (
        <div className={css.uploadsNote}>
          Missions remain here until they are processed. They can still be re-uploaded.
        </div>
      )}

      {sortedDates.map((date) => {
        const missions = missionsKeyedByDates![date];

        return (
          <section key={date} className={css.section} data-intercom-target="SchedulesTabSection">
            <ScheduleHeader date={date} schedules={missions} />

            {missions.map(({ site, customer, schedule, gcpPlacementService }) => (
              <MissionCard
                key={schedule?.airtableRecordId ?? gcpPlacementService?.airtableRecordId}
                schedule={schedule}
                customer={customer}
                site={site}
                gcpPlacementService={gcpPlacementService}
              />
            ))}
          </section>
        );
      })}
    </div>
  );
};
